<template>
    <div>
        <b-card class="sa-card sa-card-border mb-3" header="Linguaggio scritto (L.scr 3)" header-tag="header">
            <b-row>
                <b-col class="aat-field" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data" for="aat-linguaggio-scritto-mano-usata">Mano usata — DX / SX</label>
                    <b-form-radio-group id="aat-linguaggio-scritto-mano-usata" v-model="jsonDataLinguaggioScritto.linguaggioScrittoManoUsata" name="aat-linguaggio-scritto-mano-usata" class="d-flex flex-wrap aat-options" :options="manoUsataOptions" :disabled="isReadOnly"></b-form-radio-group>
                    <span v-if="jsonDataLinguaggioScritto.linguaggioScrittoManoUsata != null && !manoUsataOptions.includes(jsonDataLinguaggioScritto.linguaggioScrittoManoUsata)" class="sa-label-data-secondary">{{ jsonDataLinguaggioScritto.linguaggioScrittoManoUsata }}</span>
                </b-col>
                <b-col class="aat-field" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                    <label class="sa-label-data">Note</label>
                    <b-form-input v-model="jsonDataLinguaggioScritto.linguaggioScrittoNote" type="text" :readonly="isReadOnly"></b-form-input>
                </b-col>
                <b-col class="aat-field" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                    <label class="sa-label-data">Osservazioni</label>
                    <b-form-textarea v-model="jsonDataLinguaggioScritto.linguaggioScrittoOsservazioni" class="aat-textarea" rows="3" no-resize :readonly="isReadOnly"></b-form-textarea>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
export default {
    name: "RsaSchedaAachenerAphasieTestScritturaManoEditComponent",
    props: {
        jsonDataLinguaggioScritto: { type: Object, required: true },
        isReadOnly: { type: Boolean, default: false },
    },
    data() {
        return {
            manoUsataOptions: ["DX", "SX"],
        };
    },
};
</script>

<style scoped>
.aat-field {
    margin-bottom: 1rem;
}
.aat-field .sa-label-data {
    align-items: flex-end;
    display: flex;
    min-height: 2.5rem;
}
.aat-textarea {
    height: 7rem;
    resize: none;
}
.aat-options {
    gap: 0.75rem;
}
</style>
